// Example for LibraryAdmin page
export const sideBarTourSteps = [
  {
    target: ".dashboard", // CSS selector for the element
    content: "Click here to create a new library.",
  },
  {
    target: ".profile", // CSS selector for the delete button
    content: "Use this button to view libraries and sub-libraries.",
  },
  {
    target: ".dog", // CSS selector for the delete button
    content: "Use this button to delete a library.",
  },
  {
    target: ".library", // Tag input field
    content: "Choose a library to upload a file to.",
  },
  {
    target: ".memorial", // Tag input field
    content: "Enter a file name.",
  },
  {
    target: ".directory", // Tag input field
    content: "Enter a date that the file must be reviewed by.",
  },
  {
    target: ".marketplace", // Tag input field
    content: "Choose a date the document is to be deleted.",
  },
  {
    target: ".question", // Tag input field
    content: "Type tags here and press Enter to add them.",
  },
  {
    target: ".calendar", // Tag input field
    content: "Choose the file to upload.",
  },
  {
    target: ".contact", // Upload button
    content: "Click this button to upload your files.",
  },
  {
    target: ".faq", // Upload button
    content: "Click this button to upload your files.",
  },
];

// Example for LibraryAdmin page
export const libraryAdminTourSteps = [
    {
      target: ".btn-soft-success", // CSS selector for the element
      content: "Click here to create a new library.",
    },
    {
      target: ".libraryAccordion", // CSS selector for the delete button
      content: "Use this button to view libraries and sub-libraries.",
    },
    {
      target: ".deleteLibrary", // CSS selector for the delete button
      content: "Use this button to delete a library.",
    },
    {
      target: ".formParent", // Tag input field
      content: "Choose a library to upload a file to.",
    },
    {
      target: ".formFileName", // Tag input field
      content: "Enter a file name.",
    },
    {
      target: ".formReview", // Tag input field
      content: "Enter a date that the file must be reviewed by.",
    },
    {
      target: ".formDelete", // Tag input field
      content: "Choose a date the document is to be deleted.",
    },
    {
      target: ".formTags", // Tag input field
      content: "Type tags here and press Enter to add them.",
    },
    {
      target: ".doc-uploader", // Tag input field
      content: "Choose the file to upload.",
    },
    {
      target: ".btn-primary", // Upload button
      content: "Click this button to upload your files.",
    },
  ];
  